import VERSION from './version';
export const BASE_MODULE_NAME = `MW.VisualizationsV${VERSION}`;
